import { handleVersionMismatch } from 'actions/versionSync';
import * as MessagesActionTypes from 'actiontypes/messages';
import { VersionMismatch } from 'services/BaseService';
import MessagesService from 'services/MessagesService';
import { IMessagesService } from 'types/messages';

const rejectRequested = () => ({ type: MessagesActionTypes.REJECT_REQUESTED });

const rejectSuccess = (invitationId: number) => ({
  payload: { invitationId },
  type: MessagesActionTypes.REJECT_SUCCESS,
});

const rejectFailure = (error: any) => ({
  type: MessagesActionTypes.REJECT_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
* REJECT A REQUEST
-----------------------------------------------------------------------------*/
export default reject(new MessagesService());

export function reject(service: IMessagesService) {
  return (invitationId: number) => async (dispatch: Function) => {
    dispatch(rejectRequested());
    try {
      await service.rejectInvitation(invitationId);
      dispatch(rejectSuccess(invitationId));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
      }
      dispatch(rejectFailure(error));
    }
  };
}